// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-manager {
  position: fixed;
  display: none;
  bottom: 0px;
  right: 3%;
  width: 300px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 10px 10px 0 0;
  --header-height: 30px;
  --line-height: 50px;
  --max-queue-height: calc(var(--line-height) * 3);
}
.upload-manager.show {
  display: inline;
}
.upload-manager.hide-details {
  --max-queue-height: calc(var(--line-height) * 0.5);
}
.upload-manager.hide-details:hover {
  --max-queue-height: calc(var(--line-height) * 1.5);
}
.upload-manager .upload-manager-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--header-height);
  padding: 5px 10px;
  background-color: var(--motes-dark);
  font-size: small;
  font-weight: bold;
}
.upload-manager .upload-manager-header .header-icons > * {
  margin-left: 10px;
}
.upload-manager .close-icon {
  font-size: 21px;
  cursor: pointer;
  transition: 300ms;
}
.upload-manager .close-icon:hover {
  color: var(--motes-highlight-color);
  transform: scale(1.2);
  transition: 150ms;
}
.upload-manager .upload-manager-content {
  background-color: var(--motes-dark);
  color: var(--motes-dark);
  border: 1px solid var(--motes-dark);
}
.upload-manager .upload-queue {
  overflow-y: auto;
  max-height: var(--max-queue-height);
  transition: max-height 0.5s cubic-bezier(0.6, 0, 0, 1);
  width: 100%;
}
.upload-manager .upload-file {
  pointer-events: none;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: var(--line-height);
}
.upload-manager .upload-file:not(:last-child) {
  border-bottom: 1px solid var(--motes-dark);
}
.upload-manager .upload-icon {
  display: block;
  overflow: hidden;
  width: var(--line-height);
  height: var(--line-height);
  color: black;
}
.upload-manager .progress-bar {
  display: grid;
  width: 100%;
}
.upload-manager .progress-bar .upload-text {
  line-height: var(--line-height);
  padding-left: 6px;
}
.upload-manager .progress-bar .upload-text.black {
  color: black;
  z-index: 3;
}
.upload-manager .progress-bar .upload-text.white {
  color: white;
  z-index: 1;
}
.upload-manager .progress-bar .progress-fill {
  background-color: var(--motes-gold);
  overflow-x: hidden;
  white-space: nowrap;
  transition: width 500ms;
  z-index: 2;
}
.upload-manager .progress-bar .progress-fill.failed {
  background-color: var(--motes-red);
}
.upload-manager .progress-bar .progress-fill.failed span {
  color: white;
}
.upload-manager .progress-bar > * {
  grid-column: 1/1;
  grid-row: 1/1;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/upload-manager/upload-manager.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EAEA,qBAAA;EACA,mBAAA;EACA,gDAAA;AAAJ;AAEI;EACI,eAAA;AAAR;AAGI;EACI,kDAAA;AADR;AAII;EACI,kDAAA;AAFR;AAKI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;AAHR;AAKQ;EACI,iBAAA;AAHZ;AAOI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;AALR;AAQI;EACI,mCAAA;EACA,qBAAA;EACA,iBAAA;AANR;AASI;EACI,mCAAA;EACA,wBAAA;EACA,mCAAA;AAPR;AAUI;EACI,gBAAA;EACA,mCAAA;EACA,sDAAA;EACA,WAAA;AARR;AAWI;EACI,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;EACA,0BAAA;AATR;AAYI;EACI,0CAAA;AAVR;AAaI;EACI,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,YAAA;AAXR;AAcI;EACI,aAAA;EACA,WAAA;AAZR;AAcQ;EACI,+BAAA;EACA,iBAAA;AAZZ;AAcY;EACI,YAAA;EACA,UAAA;AAZhB;AAeY;EACI,YAAA;EACA,UAAA;AAbhB;AAiBQ;EACI,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAfZ;AAiBY;EACI,kCAAA;AAfhB;AAiBgB;EACI,YAAA;AAfpB;AAqBI;EACI,gBAAA;EACA,aAAA;AAnBR","sourcesContent":[".upload-manager {\n    position: fixed;\n    display: none;\n    bottom: 0px;\n    right: 3%;\n    width: 300px;\n    overflow: hidden;\n    cursor: pointer;\n    border-radius: 10px 10px 0 0;\n\n    --header-height: 30px;\n    --line-height: 50px;\n    --max-queue-height: calc(var(--line-height) * 3);\n\n    &.show {\n        display: inline;\n    }\n\n    &.hide-details {\n        --max-queue-height: calc(var(--line-height) * 0.5);\n    }\n\n    &.hide-details:hover {\n        --max-queue-height: calc(var(--line-height) * 1.5);\n    }\n\n    .upload-manager-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: var(--header-height);\n        padding: 5px 10px;\n        background-color: var(--motes-dark);\n        font-size: small;\n        font-weight: bold;\n\n        .header-icons>* {\n            margin-left: 10px;\n        }\n    }\n\n    .close-icon {\n        font-size: 21px;\n        cursor: pointer;\n        transition: 300ms;\n    }\n\n    .close-icon:hover {\n        color: var(--motes-highlight-color);\n        transform: scale(1.2);\n        transition: 150ms;\n    }\n\n    .upload-manager-content {\n        background-color: var(--motes-dark);\n        color: var(--motes-dark);\n        border: 1px solid var(--motes-dark);\n    }\n\n    .upload-queue {\n        overflow-y: auto;\n        max-height: var(--max-queue-height);\n        transition: max-height 0.5s cubic-bezier(0.6, 0, 0, 1);\n        width: 100%;\n    }\n\n    .upload-file {\n        pointer-events: none;\n        display: flex;\n        justify-content: flex-start;\n        width: 100%;\n        height: var(--line-height);\n    }\n\n    .upload-file:not(:last-child) {\n        border-bottom: 1px solid var(--motes-dark);\n    }\n\n    .upload-icon {\n        display: block;\n        overflow: hidden;\n        width: var(--line-height);\n        height: var(--line-height);\n        color: black;\n    }\n\n    .progress-bar {\n        display: grid;\n        width: 100%;\n\n        .upload-text {\n            line-height: var(--line-height);\n            padding-left: 6px;\n\n            &.black {\n                color: black;\n                z-index: 3;\n            }\n\n            &.white {\n                color: white;\n                z-index: 1;\n            }\n        }\n\n        .progress-fill {\n            background-color: var(--motes-gold);\n            overflow-x: hidden;\n            white-space: nowrap;\n            transition: width 500ms;\n            z-index: 2;\n\n            &.failed {\n                background-color: var(--motes-red);\n\n                span {\n                    color: white;\n                }\n            }\n        }\n    }\n\n    .progress-bar>* {\n        grid-column: 1 / 1;\n        grid-row: 1 / 1;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
